var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
function isString(str) {
    return typeof str === 'string';
}
export default class Step extends React.Component {
    renderIconNode() {
        const { prefixCls, progressDot, stepNumber, status, title, description, icon, iconPrefix, icons, } = this.props;
        let iconNode;
        const iconClassName = classNames(`${prefixCls}-icon`, `${iconPrefix}icon`, {
            [`${iconPrefix}icon-${icon}`]: icon && isString(icon),
            [`${iconPrefix}icon-check`]: !icon && status === 'finish' && (icons && !icons.finish),
            [`${iconPrefix}icon-close`]: !icon && status === 'error' && (icons && !icons.error),
        });
        const iconDot = <span className={`${prefixCls}-icon-dot`}/>;
        // `progressDot` enjoy the highest priority
        if (progressDot) {
            if (typeof progressDot === 'function') {
                iconNode = (<span className={`${prefixCls}-icon`}>
            {progressDot(iconDot, { index: stepNumber - 1, status, title, description })}
          </span>);
            }
            else {
                iconNode = <span className={`${prefixCls}-icon`}>{iconDot}</span>;
            }
        }
        else if (icon && !isString(icon)) {
            iconNode = <span className={`${prefixCls}-icon`}>{icon}</span>;
        }
        else if (icons && icons.finish && status === 'finish') {
            iconNode = <span className={`${prefixCls}-icon`}>{icons.finish}</span>;
        }
        else if (icons && icons.error && status === 'error') {
            iconNode = <span className={`${prefixCls}-icon`}>{icons.error}</span>;
        }
        else if (icon || status === 'finish' || status === 'error') {
            iconNode = <span className={iconClassName}/>;
        }
        else {
            iconNode = <span className={`${prefixCls}-icon`}/>;
        }
        return iconNode;
    }
    render() {
        const _a = this.props, { className, prefixCls, style, status = 'wait', iconPrefix, icon, wrapperStyle, stepNumber, description, title, progressDot, tailContent, icons } = _a, restProps = __rest(_a, ["className", "prefixCls", "style", "status", "iconPrefix", "icon", "wrapperStyle", "stepNumber", "description", "title", "progressDot", "tailContent", "icons"]);
        const classString = classNames(`${prefixCls}-item`, `${prefixCls}-item-${status}`, className);
        const isCmsIconNode = `${prefixCls}-item-custome-icon`;
        const itemIconCls = classNames(`${prefixCls}-item-icon`, {
            [isCmsIconNode]: icon && !isString(icon),
        });
        const stepItemStyle = Object.assign({}, style);
        return (<div {...restProps} className={classString} style={stepItemStyle}>
        <div className={`${prefixCls}-item-tail`}>
          {tailContent}
        </div>
        <div className={itemIconCls}>
          {this.renderIconNode()}
        </div>
        <div className={`${prefixCls}-item-content`}>
          <div className={`${prefixCls}-item-title`}>
            {title}
          </div>
          {description && <div className={`${prefixCls}-item-description`}>{description}</div>}
        </div>
      </div>);
    }
}



// WEBPACK FOOTER //
// ./components/steps/Step.tsx